export default __webpack_public_path__ + "static/media/six_of_wands.116286b7.png";